import { useRoutes } from "react-router-dom";
import { ContainerSite, Root, ScrollBars } from "./AppContainer.styles";
import { appRoutes } from "../../../configuration/appRoutes";

export default function AppContainer() {
  const routes = useRoutes(appRoutes);
  return (
    <Root>
      <ScrollBars useNative>
        {/*<ContainerSite>*/}
          {routes}
          {/*</ContainerSite>*/}
      </ScrollBars>
    </Root>
  );
}
